/*
 * Copyright (c) CIRROM 2026.
 */

import React from "react";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { CandidateSource } from "./helpers/normalize";

/*
 * Provenance marker for a proposed value.
 *
 * Provenance is not health, so these carry neutral chrome only: no ramp
 * colours (the One Ramp Rule keeps red/green for the health score) and no
 * amber (rationed to the shell and the committing action). The label does the
 * work; the chip just keeps it out of the value's way.
 */
const SOURCE_LABELS: Record<CandidateSource, { label: string; title: string }> =
  {
    cirrom: {
      label: "Cirrom",
      title: "Suggested by Cirrom data quality",
    },
    monitor: {
      label: "LinkedIn",
      title: "Detected by Cirrom Monitor on LinkedIn",
    },
    // Reserved for the future inline-edit affordance; nothing produces it yet.
    manual: {
      label: "Manual",
      title: "Entered by a steward",
    },
  };

export const SourceChip = (props: { source: CandidateSource }) => {
  const { label, title } = SOURCE_LABELS[props.source];
  return (
    <Tooltip title={title}>
      <Chip
        label={label}
        size="small"
        variant="outlined"
        sx={{
          color: "text.secondary",
          borderColor: "divider",
          height: "20px",
          // MUI's small chip drops to 12px; the Thirteen Rule holds outside a
          // coloured block, and this chip is a hairline outline.
          "& .MuiChip-label": { fontSize: "13px" },
        }}
      />
    </Tooltip>
  );
};
